import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { siteStats } from '@/mocks/site';

export default function HeroSection() {
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    const query = keyword.trim();
    navigate(query ? `/incidents?q=${encodeURIComponent(query)}` : '/incidents');
  };

  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20editorial%20illustration%20of%20a%20radar%20sweeping%20over%20a%20digital%20city%20of%20data%20packets%2C%20deep%20rust%20red%20and%20amber%20glow%2C%20moody%20teal%20shadows%2C%20minimal%20clean%20composition%2C%20serious%20investigative%20atmosphere&width=1800&height=1000&seq=home-hero-2026&orientation=landscape"
          alt="黑料雷达首页主视觉：安全风险监测与事件扫描"
          title="黑料雷达 - 网站安全事件与隐私风险情报"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/75"></div>
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="max-w-3xl">
          <p className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 text-xs text-background-100 backdrop-blur">
            <span className="flex h-3.5 w-3.5 items-center justify-center">
              <i className="ri-radar-line text-[13px] text-accent-300"></i>
            </span>
            安全事件 · 隐私风险 · 合规通报
          </p>
          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
            看清平台的另一面
            <br />
            再决定要不要交出你的数据
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-7 text-background-200 md:text-base">
            我们整理数据泄露、安全漏洞、盗刷事件、违规收集使用个人信息与监管处罚记录，
            用克制的语言还原经过，并给出可以马上执行的自保动作。
          </p>

          <form onSubmit={handleSearch} className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row">
            <div className="flex flex-1 items-center gap-2 rounded-md border border-background-50/25 bg-background-50/95 px-3 py-2.5">
              <span className="flex h-4 w-4 items-center justify-center text-foreground-500">
                <i className="ri-search-line text-base"></i>
              </span>
              <input
                type="search"
                name="keyword"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索平台类型、风险关键词，如「数据泄露」"
                aria-label="搜索安全事件"
                className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-md bg-primary-600 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-500"
            >
              检索事件库
            </button>
          </form>

          <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-background-200">
            <span className="text-background-300">热门检索：</span>
            {['数据泄露', '免密代扣', '越权访问', '超范围索权'].map((tag) => (
              <Link
                key={tag}
                to={`/incidents?q=${encodeURIComponent(tag)}`}
                className="underline decoration-background-50/40 underline-offset-4 transition-colors hover:text-background-50"
              >
                {tag}
              </Link>
            ))}
          </div>
        </div>

        <dl className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-50/15 bg-background-50/10 backdrop-blur md:mt-16 lg:grid-cols-4">
          {siteStats.map((stat) => (
            <div key={stat.label} className="bg-background-950/20 px-5 py-5">
              <dt className="text-xs text-background-300">{stat.label}</dt>
              <dd className="mt-1.5 font-heading text-2xl font-bold text-background-50">{stat.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}